import { ref } from '@vue/composition-api'

export function useFixedOverlay() {
  const bodyPosition = ref('')
  const bodyTop = ref('')
  const isOpen = ref(false)

  function open() {
    isOpen.value = true
    // prevent body in background to be scrollable
    bodyPosition.value = document.body.style.position
    bodyTop.value = document.body.style.top
    document.body.style.top = `-${window.scrollY}px`
    document.body.style.position = 'fixed'
  }

  function close() {
    isOpen.value = false
    // set body back to be scrollable
    const scrollY = document.body.style.top
    document.body.style.position = bodyPosition.value
    document.body.style.top = bodyTop.value
    window.scrollTo(0, Math.abs(parseInt(scrollY || '0', 10)))
  }

  function toggle() {
    isOpen.value ? close() : open()
  }

  return {
    open,
    close,
    toggle,
    isOpen,
  }
}
